import React from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Banner() {
  const [textRef, textVisible] = useScrollAnimation();
  const [buttonsRef, buttonsVisible] = useScrollAnimation();
  const { t } = useTranslation();

  return (
    <div className="banner-wrapper">
      <div className="container">
        <div className="banner">
        <div
          ref={textRef}
          className={`banner-text ${textVisible ? "animate-in" : ""}`}
        >
          <h1 className="fs-900 clr-white">
            {t("banner.title")}
          </h1>
          <p className="fs-500 clr-white">
            {t("banner.description")}
          </p>
        </div>
        <div
          ref={buttonsRef}
          className={`flex buttons ${buttonsVisible ? "animate-in" : ""}`}
        >
          <Link to="/contact">
            <button className="fs-500 clr-white transition pointer button-green">
                Contact Us
            </button>
          </Link>
          <Link to="/about">
            <button className="fs-500 clr-white transition pointer">
                Learn More
            </button>
          </Link>
        </div>
        <div className="rectangular"></div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
